<template lang="pug">
  .rounded-tag(
    :style="style"
    @click="($emit('click', $event))"
  )
    .rounded-tag__icon-wrapper(
      v-if="icon"
      :style="iconWrapperStyle"
    )
      .rounded-tag__icon(
        :style="iconStyle"
      )
    span.rounded-tag__text {{ text }}
</template>

<script>
export default {
  props: {
    text: String,
    height: String,
    baselineShift: {
      type: Number,
      default: -0.05
    },
    icon: String
  },

  computed: {
    borderRadius() {
      return `calc(${this.height} / 2)`
    },

    padding() {
      const padding = `calc(${this.height} * 0.35)`
      return this.icon ? `0 ${padding} 0 0` : `0 ${padding}`
    },

    lineHeight() {
      // Apply baseline shift.
      return `calc(${this.height} * ${1 - this.baselineShift})`
    },

    style() {
      return {
        'border-radius': this.borderRadius,
        padding: this.padding,
        'line-height': this.lineHeight,
        height: this.height
      }
    },

    iconStyle() {
      return {
        'background-image': `url(${this.icon})`
      }
    },

    iconWrapperStyle() {
      return {
        width: this.height,
        height: this.height
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.rounded-tag {
  display: inline-flex;
  box-sizing: content-box;

  &__icon-wrapper {
    padding: 0.5em;
    margin-right: 0.35em;
  }

  &__icon {
    width: 100%;
    height: 100%;
    background-size: cover;
    border-radius: 50%;
  }
}
</style>
